/* eslint-disable react/prop-types */
import React from 'react';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import {
  Card,
  CardContent,
  Slide,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import {
  playerLocationBlocks,
  shotTypes,
  spinLevels,
  steps,
} from './constants';

const StepperContent = ({
  step,
  playerLocation,
  handleSelectLocationBlock,
  selectedLocationBlock,
  handleSelectShotType,
  selectedShotType,
  handleSelectSpinLevel,
  selectedSpinLevel
}) => {
  switch (steps[step]) {
    case 'Select Location Block':
      return (
        <Slide direction="left" in={true} mountOnEnter unmountOnExit>
          <Grid2
            container spacing={2}
            sx={{
              width: '100%',
              mt: 4,
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              flexDirection: 'column'
            }}
          >
            <Box width="450px" display="flex" flexDirection="row" flexWrap="wrap" justifyContent={'center'} gap={2}>
              {playerLocationBlocks.map((location, index) => (
                <Card
                  variant="outlined"
                  onClick={() => handleSelectLocationBlock(location.locationId)}
                  sx={{
                    width: '100px',
                    cursor: 'pointer',
                    border: playerLocation === location.locationId ? '2px solid #fcba03' : '1px solid #ccc'
                  }}
                  key={index}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '24px',
                          fontWeight: '800',
                          lineHeight: '36px',
                          color: '#4935FF',
                        }}
                      >
                        {location.locationId}
                      </Typography>
                      {selectedLocationBlock === location.locationId && (
                        <CheckCircleIcon sx={{ color: '#39B549' }}/>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
            <Box width="450px" height="1.5rem" backgroundColor={'green'} color="#fff" textAlign="center">
              {'net'}
            </Box>
          </Grid2>
        </Slide>
      );
    case 'Shot Type':
      return (
        <Slide direction="left" in={true} mountOnEnter unmountOnExit>
          <Grid2 container spacing={2} sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
            {Object.keys(shotTypes).map((shotType, index) => (
              <Grid2 xs={12} sm={6} md={3} key={index}>
                <Card
                  variant="outlined"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleSelectShotType(shotTypes[shotType].id)}
                >
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', height: '30px' }}>
                      {selectedShotType === shotType.id && (
                        <CheckCircleIcon sx={{ color: '#39B549' }}/>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '24px',
                          fontWeight: '800',
                          lineHeight: '36px',
                          color: '#4935FF',
                        }}
                      >
                        {shotTypes[shotType].title}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Slide>
      );
    case 'Spin Level':
      return (
        <Slide direction="left" in={true} mountOnEnter unmountOnExit>
          <Grid2 container spacing={2} sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
            {Object.keys(spinLevels).map((spinLevel, index) => (
              <Grid2 xs={12} sm={6} md={3} key={index}>
                <Card
                  variant="outlined"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleSelectSpinLevel(spinLevel)}
                >
                  <CardContent>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', height: '30px' }}>
                      {selectedSpinLevel === spinLevel && (
                        <CheckCircleIcon sx={{ color: '#39B549' }}/>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '24px',
                          fontWeight: '800',
                          lineHeight: '36px',
                          color: '#4935FF',
                        }}
                      >
                        {spinLevels[spinLevel].title}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Slide>
      );
    default:
      return null;
  }
};

export default StepperContent;
